import { BasePublicApi } from '#packages/apilib';
import { CompPointersScope } from './compPointersScope';

import type { CompPointer } from './compPointersTypes';
import type { CompRef, VariantPointer } from 'types/documentServices';
import type { StageContext } from '#packages/stageContext';

function buildCompPointerWithVariants(
  scope: CompPointersScope,
  compRef: CompRef,
  variants: VariantPointer[],
): CompPointer {
  if (!variants) {
    return { _key: 'CompPointer', ...compRef };
  }

  return {
    _key: 'CompPointer',
    ...scope.editorAPI.components.variants.getPointer(compRef, variants),
  };
}

function withContext(
  scope: CompPointersScope,
  compRef: CompRef,
  context: StageContext,
): CompPointer {
  if (!compRef) {
    return null;
  }

  return buildCompPointerWithVariants(scope, compRef, context.variants);
}

/**
 * Converts a compRef to a compPointer and a current context to the result pointer.
 */
function withCurrentContext(
  scope: CompPointersScope,
  compRef: CompRef,
): CompPointer {
  if (!compRef) {
    return null;
  }

  const { stageContextApi } = scope;
  const context = stageContextApi.getCurrentContextForRef(compRef);

  return withContext(scope, compRef, context);
}

export class CompPointersApi extends BasePublicApi<CompPointersScope> {
  withContext = this.bindScope(withContext);
  withCurrentContext = this.bindScope(withCurrentContext);
}
